module.exports = __webpack_public_path__ + "assets/img/box1-6.d1a5fbbc.svg";